import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { SapService } from 'src/app/api/sap.service';
import { variableGlobal } from 'src/app/global.enum';
import Swal from 'sweetalert2';
import { AddMaterialesComponent } from '../add-materiales/add-materiales.component';

@Component({
  selector: 'app-crear-lista-materiales',
  templateUrl: './crear-lista-materiales.component.html',
  styleUrls: ['./crear-lista-materiales.component.css']
})
export class CrearListaMaterialesComponent implements OnInit {

  constructor(
    private _api:IntranetoldService,
    private _sap: SapService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,

  ) { }

  public configuration: Config;
  public columns: Columns[];

  data: any;
  crear: Boolean;
  itemCrear:any;
  titulo:any;
  ngOnInit(): void {

    this.cargaInicial();

  }

  async cargaInicial() {

    if (this.crear) {
      this.titulo = "Crear";
      
    }else{
      this.titulo = "Actualizar";

      let data:any = await this._sap.obtieneListaMaterial(this.data.Code)
      this.data = data.resultado;
      

    }

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: false,
      detailsTemplate: true,
      paginationRangeEnabled: true,
      paginationEnabled: true,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };

    this.columns = [

//      { key: '', title: '#' },
//      { key: '', title: 'Tipo' },
      { key: 'Code', title: 'N°' },
      { key: 'U_IND_SWW', title: 'Código Transworld' },
 //     { key: '', title: 'Código antiguo' },
      { key: 'ItemName', title: 'Descripción' },
      { key: 'Quantity', title: 'Cantidad' },
      { key: '', title: 'Acción' },
//      { key: '', title: 'Nombre de unidad de medida' },
//      { key: '', title: 'Almacén' },
 //     { key: '', title: 'Método emisión' },
 //     { key: '', title: 'Costo estándar de producción' },
 //     { key: '', title: 'Costo estándar de producción total' },
 //     { key: '', title: 'Lista de precios' },
 //     { key: '', title: 'Precio unitario' },
   //   { key: '', title: 'Total' },
   //   { key: '', title: 'Comentarios' },
   //   { key: '', title: 'Norma de reparto' },
   //   { key: '', title: 'Cta.WIP' },
  //    { key: '', title: 'Secuencia de ruta' },

    ];

  }

  borrarDetalle(rowIndex: number){

    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.data.iTT1.splice(rowIndex, 1);
        
        this.data.iTT1 = [...this.data.iTT1];
      } else {

      }
    });


  }

  crearDetalle(){


    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      windowClass: 'full-width-modal',
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(AddMaterialesComponent, ngbModalOptions);
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.crear = true;
    modalRef.componentInstance.ActualItemCode = this.data.Code;
    modalRef.result.then(async (data) => {
      if (data) {
        let body = {
          "Father": "",
          "ChildNum": 0,
          "VisOrder": 0,
          "Code": data.ItemCode,
          "Quantity": 0,
          "Warehouse": "",
          "Price": 0,
          "Currency": "",
          "PriceList": 0,
          "OrigPrice": 0,
          "OrigCurr": "",
          "IssueMthd": "",
          "Uom": null,
          "Comment": "",
          "LogInstanc": null,
          "Object": "",
          "OcrCode": null,
          "OcrCode2": null,
          "OcrCode3": null,
          "OcrCode4": null,
          "OcrCode5": null,
          "PrncpInput": "",
          "Project": null,
          "Type": 0,
          "WipActCode": null,
          "AddQuantit": 0,
          "LineText": null,
          "StageId": null,
          "ItemName": data.ItemName,
          'userFields':[
            {
              Field:"U_IND_Cod_antiguo",
              Value:data.U_IND_SWW
            }
          ]
        }
        this.data.iTT1.push(body);
        this.data.iTT1 = [...this.data.iTT1];
      }
    });


  }

  async crearLista(){
    let res:any = await this._sap.creaActualizaListaMaterial(this.data);

    if (res.estado) {

      Swal.fire({
        title: 'Éxito',
        text: res.mensaje,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });

    }
    else
    {

      Swal.fire({
        title: 'Error',
        text: res.mensaje,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });

    }

    
    

  }

  cerrar() {
    this.activeModal.close();
  }

}
